import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import { Button, ButtonContent } from 'components/Common/MasterComponents'
import Description from './Description'
import { ActionsBlock, Main } from '../_styles'
import { FIELDS } from '../_methods'
import BottleImages from '../../ImagesUpdateDialog/Form/BottleImages'
import AdditionalPhotos from '../../ImagesUpdateDialog/Form/AdditionalPhotos'
import LoadingRecognition from '../../ImagesUpdateDialog/Form/LoadingRecognition'

interface FormProps {
  loading: boolean
  onClose: () => void
  handleRecognise: () => void
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const Body = styled.div`
  display: flex;
  flex: 1;

  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`
const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
`
const Form: FC<FormProps> = ({ loading, onClose, handleRecognise }) => {
  const { t } = useTranslation()
  const { watch } = useFormContext()

  const { frontLabel, backLabel } = watch(`${FIELDS.BOTTLE_IMAGES}`)
  const isRecogniseDisabled = !frontLabel || !backLabel

  return (
    <>
      {loading ? (
        <div data-testid='recognize-wine-modal-loading'>
          <LoadingRecognition />
        </div>
      ) : (
        <>
          <Description />
          <Main data-testid='recognize-wine-modal-upload-form'>
            <Wrapper>
              <Body>
                <Container>
                  <ImagesWrapper>
                    <BottleImages
                      bottleImageTitle={'dialogs.recognizeWine.packshot'}
                    />
                    <AdditionalPhotos />
                  </ImagesWrapper>
                </Container>
              </Body>
            </Wrapper>
          </Main>
          <ActionsBlock>
            <Button
              $size='L'
              $type='secondary'
              onClick={onClose}
              data-testid='recognize-wine-modal-cancel-button'
            >
              {t('common.cancel')}
            </Button>
            <Button
              $size='L'
              $type='primary'
              onClick={handleRecognise}
              $fakeDisabled={isRecogniseDisabled || loading}
              data-testid='recognize-wine-modal-submit-button'
            >
              <ButtonContent loading={loading}>
                {t('dialogs.recognizeWine.actions.recognizeWine')}
              </ButtonContent>
            </Button>
          </ActionsBlock>
        </>
      )}
    </>
  )
}

export default Form
